export {default} from './scrolling-news-filter';
